import styled from 'styled-components';

export const OpenMarketProductListDetailCardGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 32px;
  align-self: stretch;
`;
